module.exports = __webpack_public_path__ + "img/hook_MARTEC_BKL_4.f238ff19.png";